import { render, staticRenderFns } from "./_Highlight.vue?vue&type=template&id=0af8ae71&"
import script from "./_Highlight.vue?vue&type=script&lang=js&"
export * from "./_Highlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports